<template>
  <div>
    <template v-if="loading">
      <md-progress-bar md-mode="query" class="md-accent"></md-progress-bar>
    </template>
    <template v-else>
      <div class="md-layout container" style="margin-bottom: 16px">
        <md-field>
          <h3>{{$t("games.downloadImages.title")}}</h3>
        </md-field>
        <strong>{{$t("games.downloadImages.avaliable")}} : {{totalImages}} | {{$t("games.downloadImages.selected")}}: {{imageSelect.length}}</strong>
      </div>
      <div class="md-layout container">
        <md-button class="md-default" @click="selectAllPage()">{{$t("games.downloadImages.selectAllPage")}}</md-button>
        <md-button class="md-success" v-if="totalImages > 0" :disabled="download || imageSelect.length == 0" @click="downloadImages()">{{$t("games.downloadImages.download")}}</md-button>
      </div>
      <div class="md-layout container">
        <md-card class="md-layout-item card md-size-20" v-for="(image, idxImage) in listImages" :key="idxImage">
          <md-checkbox v-model="imageSelect" :value="image.id">
            <md-card-media>
              <badge type="info" v-if="getNameImage(image.picture)">{{getNameImage(image.picture)}}</badge> 
              <img :src="getUrlImage(image.picture)" alt="Image">
            </md-card-media>
          </md-checkbox>
        </md-card>
      </div>
      <div class="md-layout footer container">
        <div>
          <pagination
            v-if="totalImages > 50"
            type="info"
            v-model="pageActual"
            :page-count="totalImages / 50">
          </pagination>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {Pagination, Badge} from '@/components'

export default {
  components: {
    Pagination,
    Badge
  },
  data() {
    return {
      loading: true,
      listImages: [],
      imageSelect: [],
      totalImages: 0,
      pageActual: 1,
      download: false
    }
  },
  mounted() {
    this.getFanPicture()
  },
  methods: {
    getUrlImage(image) {
      return `${process.env.VUE_APP_CDN_URL_FAN_PICTURES}${image}`
    },
    getNameImage(path) {
      const split = path.split("--")
      return split.length > 1 ? split[0].replace("-", " ") : ""
    },
    async getFanPicture() {
      this.loading = true
      const params = {
        gameId: this.$route.params.gameId,
        teamId: this.$route.params.teamId,
        pageNumber: this.pageActual - 1,
        rowsPerPage: 50
      }
      const response = await this.$store.dispatch("getFanPictureApproved", params)
      if (response != undefined) {
        this.listImages = response.data.data
        this.totalImages = response.data.totalResults
        this.loading = false
        this.download = false
      }
    },
    selectAllPage() {
      this.listImages.forEach(image => {
        if (!this.imageSelect.includes(image.id)) this.imageSelect.push(image.id)
      })
    },
    async downloadImages() {
      this.download = true
      const download = await this.$store.dispatch('downloadFanPictures', this.imageSelect)
      if (download.status == 200) {
        const a = document.createElement("a")
        a.href = `${process.env.VUE_APP_CDN_URL_FAN_PICTURES_ZIP}${download.data}`
        a.setAttribute("download", "download")
        a.id = 'zipImages'
        document.body.appendChild(a);
        a.click();
        document.getElementById('zipImages').remove();  
        await this.getFanPicture()
        this.imageSelect = []
      }
    }
  },
  watch: {
    pageActual() {
      this.getFanPicture()
    }
  }
}
</script>

<style lang="scss">
.card {
  padding: 0;
  margin: 8px 0;
  background-color: #eee!important;
  background: #eee;
  box-shadow: none;

  .md-checkbox .md-checkbox-label {
    height: auto;
  }

  .md-checkbox {
    background: white;
    border-radius: 4px;
    padding: 4px;
  }

  .md-card-media {
    border-radius: 2px;
    overflow: hidden;
  }

  .badge {
    position: absolute;
    top: 4px;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
}

.header {
  margin-bottom: 16px;
}

</style>